import { Filters } from '@terminal/components/filters/Filters';
import {
  EarningFilterGroupKeys,
  FilterState,
} from '@terminal/hooks/use-filter-actions/useFilterActions';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

import { useEarningsStore } from '../../useEarningsStore/useEarningsStore';
import { ResetAllButton } from '../filters/reset-all-button/ResetAllButton';

export const EarningsFilters = () => {
  const { resetAllFilterOptions, filterGroups, onFilterGroupsChange } =
    useEarningsStore();
  const { trackEarningsFilterSelected } = usePosthogEvents();

  const filterGroupsEntries = Object.entries<FilterState>(filterGroups);
  const showResetAll =
    !!filterGroups.EARNINGS_FILTERS?.activeFilterOptions.length;

  const handleFilterOptionAdd = (optionName: string) => {
    trackEarningsFilterSelected(
      POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      optionName
    );
  };

  return (
    <>
      {filterGroupsEntries.map(([group, filterState]) => (
        <Filters
          key={group}
          filterState={filterState}
          store={useEarningsStore}
          group={group as EarningFilterGroupKeys}
          onFilterGroupsChange={onFilterGroupsChange}
          onFilterOptionAdd={handleFilterOptionAdd}
          source={POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW}
        />
      ))}
      {showResetAll && (
        <ResetAllButton resetAllFilterOptions={resetAllFilterOptions} />
      )}
    </>
  );
};
